import SwiperGame from './SwiperGame';

export default SwiperGame;
